/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Component, Input } from '@angular/core';
const TYPE_DISPLAY_TEXT = {
  do: 'Do',
  dont: "Don't",
  warn: 'Not typically recommended',
};

@Component({
  selector: 'app-do-dont',
  templateUrl: 'do-dont.component.html',
  styleUrls: ['./do-dont.component.scss'],
})
export class DoDontComponent {
  @Input() type: 'do' | 'dont' | 'warn' = 'do';
  @Input() isCard = false;
  @Input() caption = '';
  typeDisplayText = TYPE_DISPLAY_TEXT;
}
